import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ROUTES } from "@/constants";
import { BackofficeLayout } from "@/layouts/backoffice";
import { PageLoading } from "@/components/atoms";
import { TenantLayout } from "@/layouts/tenant";
import { Login } from "@/pages/backoffice";
import { SpaceCalendar, TenantLanding } from "@/pages";
import { RedirectToGlobal } from "../backoffice/guards/RedirectToGlobal";
import { RequireAuth } from "../backoffice/guards/RequireAuth";
import { RequireManagerTenant } from "../backoffice/guards/RequireManagerTenant";
import { RequireRole } from "../backoffice/guards/RequireRole";

const LazyManagerRoutes = React.lazy(
  () => import("../backoffice/manager.routes"),
);

/**
 * Routes for tenant subdomains ({slug}.tercerespacio.com.ar)
 */
export const TenantRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<TenantLayout />}>
        <Route path={ROUTES.public.home} element={<TenantLanding />} />
        <Route path={ROUTES.public.calendar} element={<SpaceCalendar />} />
      </Route>
      <Route path={ROUTES.backoffice.login} element={<Login />} />
      <Route
        path={`${ROUTES.backoffice.manager}/*`}
        element={
          <RequireAuth>
            <RequireRole roles={["ADMIN", "MANAGER"]}>
              <RequireManagerTenant>
                <BackofficeLayout />
              </RequireManagerTenant>
            </RequireRole>
          </RequireAuth>
        }
      >
        <Route
          index
          element={
            <Suspense fallback={<PageLoading />}>
              <LazyManagerRoutes />
            </Suspense>
          }
        />
        <Route
          path="*"
          element={
            <Suspense fallback={<PageLoading />}>
              <LazyManagerRoutes />
            </Suspense>
          }
        />
      </Route>
      <Route
        path={`${ROUTES.backoffice.admin}/*`}
        element={<RedirectToGlobal path={ROUTES.backoffice.admin} />}
      />
      <Route
        path={`${ROUTES.backoffice.moderar}/*`}
        element={<RedirectToGlobal path={ROUTES.backoffice.moderar} />}
      />
      <Route path="*" element={<Navigate to={ROUTES.public.home} replace />} />
    </Routes>
  );
};
